import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { SocketContext } from '@app/context/SocketContext';
import FechaFunction from '@app/functions/FechaFunction';

const ComentarioNotifyCard = ({item,toggleDropdown,isModal}) => {
    const navigate = useNavigate();
    const { sockets } = useContext( SocketContext );

    const redirect = ()=>{
        if(!item?.visto_comntf){
            sockets?.emit('newViewComentarioNotify', item?.id_comntf )
        }
        if(toggleDropdown){
            toggleDropdown();
        }
        navigate(`/tickets/${item?.ticketId_comntf}/ver`)
    }
  return (
        <div className={isModal ? "col-12" : "dropdown-item"} onClick={() => redirect()} aria-hidden="true" style={{backgroundColor: !item?.visto_comntf ? '#E3F2FF' : '#F8F8F8', cursor: 'pointer' }}>
            <div className="media">
                <img src="/img/911-logo.png" alt="login" className="iconoEmpTicketCard" />
                <div className="media-body ml-3">
                    <p style={{fontSize:!isModal && '13px'}}>
                        {item?.senduser?.nombre_p === 'Nubicom S.R.L' ? `${item?.senduser?.nombre_p} ` : `El personal ${item?.senduser?.nombre_p || ''} `}
                        realizo un comentario
                        <b>{`${item?.isInterno_comntf ? ' Interno ':' '}`}</b>
                        en el ticket 
                        <b>{` Nro ${item?.ticketId_comntf}`}</b>
                        .
                    </p>
                    <div className='row'>
                        { item?.createdAt && (
                            <p className="text-muted" style={{fontSize:!isModal && '11px'}}>
                                <i className="far fa-clock mr-1" />
                                <span>
                                {FechaFunction.timeAgoMentions(new Date(item?.createdAt))}
                                </span>
                            </p>
                        )}
                        {item?.visto_comntf &&(
                            <>
                                <p className="text-muted" style={{fontSize:!isModal && '11px'}}>
                                    <i className={`fas fa-eye mr-1 ${isModal && 'ml-md-2'}`} />
                                    {FechaFunction.format(new Date(item?.visto_comntf),'dd/MM/yyyy HH:mm:ss')}
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
  )
}

export default ComentarioNotifyCard;